import { NavLink, Outlet } from 'react-router-dom';
import css from './Program.module.css';

function Program() {
    return (
        <div className={css.main}>
            <div className={css.menu}>
                <nav className={css.nav}>
                    <NavLink to="/program/overview">Overview</NavLink>
                </nav>
                {/* <nav className={css.nav}>
                    <NavLink to="/student/details">Details</NavLink>
                </nav> */}
            </div>
            <Outlet />
        </div>
    );
}

export default Program;
